import { httpClient } from '@/infra/protocols/http';

export async function refreshToken(token: string): Promise<RefreshTokenService.Response> {
  const response = await httpClient.post<RefreshTokenService.Response>(
    `/v1/auth/refresh-token`,
    { refreshToken: token },
    {
      safeErrorStatus: [401],
    },
  );
  return response;
}

export namespace RefreshTokenService {
  export type Response = {
    accessToken: string;
    refreshToken: string;
  };
}
